import React from "react";
import { TextField, Card, Box } from "@material-ui/core";
import { Lang, Save } from "components";
import { useText } from "hooks";
import useStore from "context";
import { checkAllFields } from "helpers/throwErrorEmptiField";
import { useTranslation } from "localization/translation";
import { Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';


export const TermForm = ({ initialData, onSave, onDeleteItem }) => {
  const { lang, setErrorMsg } = useStore();
  const translation = useTranslation();
  const [text, , , input] = useText(initialData);

  const submitForm = (e) => {
    e.preventDefault();
    checkAllFields(text, setErrorMsg, onSave);
  };

  return (
    <Card className="shadow-xxl px-4 py-2 mb-4">
      <Box className="d-flex justify-content-end align-items-end mt-2">
        <Button
          onClick={onDeleteItem}
          className="btn-neutral-danger mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center"
        >
          <DeleteIcon color="error" />
        </Button>
      </Box>
      <Box component="form" onSubmit={submitForm} mb={4}>
        <Lang />
        <TextField {...input(`title_${lang}`)} label={translation.title} />
        <TextField
          {...input(`text_${lang}`)}
          multiline
          label={translation.text}
        />
        <Save />
      </Box>
    </Card>
  );
};

